<div class="w-full gap-1 flex items-center justify-between flex-grow">
    <a (click)="setPlayer(); $event.preventDefault()" class="p-1 rounded-full flex justify-center items-center cursor-pointer">
        <mat-icon
            class="text-primary-900 icon-size-5"
            [svgIcon]="isPlaying ? 'heroicons_solid:pause' : 'heroicons_solid:play'"
        >
        </mat-icon>
    </a>
    <div class="flex justify-center items-center gap-2">
        <div class="min-w-10 text-center text-md">{{currentTime | secondsToMinutes}}</div>
        <div class="flex items-center">
            <input
                type="range"
                class="max-w-26"
                step="0.1"
                [value]="currentTime"
                min="0"
                [max]="totalTime"
                (input)="setSeek($event)"
                (change)="setSeek($event)"
                [ngStyle]="{'background-size': currentTime * 100 / totalTime + '% 100%'}"
            >
        </div>
        <div class="min-w-10 text-center text-md">{{totalTime | secondsToMinutes}}</div>
    </div>
    <!-- <div class="flex justify-center items-center">
        <button mat-icon-button class="text-primary" [matMenuTriggerFor]="audioHeaderMenu">
            <mat-icon class="text-white" [svgIcon]="'heroicons_outline:dots-vertical'"></mat-icon>
            <mat-menu class="dark:bg-dark-300 max-w-13" #audioHeaderMenu>
                <button mat-menu-item (click)="setPlaybackRate(rate) ;$event.stopPropagation();">
                    <mat-icon [svgIcon]="'heroicons_outline:fast-forward'"></mat-icon>
                    {{(rate).toString().replace('.',',')}} x
                </button>
                <button mat-menu-item (click)="link.click()">
                    <a #link [href]="audio.src" target="_blank" download=""></a>
                    <mat-icon [svgIcon]="'heroicons_outline:arrow-down-tray'"></mat-icon>
                    Baixar
                </button>
            </mat-menu>
        </button>
    </div> -->
</div>
